import { createRouter, createWebHistory } from 'vue-router'
import HomeView from 'views/pages/Home.vue'
import FreeTourView from 'views/pages/FreeTour.vue'
import LoginPageView from 'views/pages/Login.vue'
import ModelsView from 'views/pages/Models.vue'
import ModelView from 'views/pages/Model.vue'
import VideosView from 'views/pages/Videos.vue'
import LivesView from 'views/pages/Lives.vue'
import AboutView from 'views/pages/About.vue'
import ContactView from 'views/pages/Contact.vue'
import ColumnsView from 'views/pages/Columns.vue'
import BlogsView from 'views/pages/Blog.vue'
import BlogIdView from 'views/pages/BlogId.vue'
import ColumnIdView from 'views/pages/ColumnId.vue'
import EcardsView from 'views/pages/Ecards.vue'
import MyAccountView from 'views/pages/MyAccount.vue'
import CancelSubscribeView from 'views/pages/CancelSubscribe.vue'
import CheckoutSuccessView from 'views/pages/CheckoutSuccess.vue'
import CheckoutCreditsSuccessView from 'views/pages/CheckoutCreditsSuccess.vue'
import LiveView from 'views/pages/Live.vue'
import PasswordResetView from 'views/pages/PasswordReset.vue'
// import MaintenanceView from 'views/pages/Maintenance.vue'
import BellaCloudView from 'views/pages/BellaCloud.vue'
import BellaCloudAlbumView from 'views/pages/BellaCloudAlbum.vue'
import BellaCloudTopView from 'views/pages/BellaCloudTops.vue'
import NotFoundView from 'views/pages/NotFound.vue'
import MyCreditsView from 'views/pages/MyCredits.vue'
import AssineCreditsView from 'views/pages/AssineCredits.vue'
import BuyCreditsView from 'views/pages/BuyCredits.vue'
import VideosDownloadsView from 'views/pages/MyVideosDownload.vue'
import AfiliadosView from 'views/pages/AfiliadosInfo.vue'
import HomePreviewView from 'views/pages/HomePreview.vue'
import AssineOptionsView from 'views/pages/AssineOptions.vue'
import AssineAccountView from 'views/pages/AssineAccount.vue'
import AssineCheckoutView from 'views/pages/AssineCheckout.vue'
import PolicyPrivacyView from "views/pages/PolicyPrivacy.vue"
import PolicyCancellationView from "views/pages/PolicyCancellation.vue"

const userLocale = navigator?.languages?.length ? navigator.languages[0] : navigator.language
const langsAccepts = ['pt-br', 'en']

const router = createRouter({
  history: createWebHistory('.'),
  routes: [
    {
      path: '/',
      redirect: {
        name: 'homePage',
        params: {
          locale: langsAccepts.includes(userLocale.toLowerCase())
            ? userLocale.toLowerCase()
            : 'pt-br'
        }
      }
    },
    { path: '/:locale', component: HomeView, name: 'homePage' },
    { path: '/:locale/404', component: NotFoundView, name: '404' },
    {
      path: '/:pathMatch(.*)*',
      component: () =>
        (window.location.href =
          '/' +
          (langsAccepts.includes(userLocale.toLowerCase()) ? userLocale.toLowerCase() : 'pt-br') +
          '/404')
    },
    { path: '/:locale/freetour', component: FreeTourView, name: 'FreeTourPage' },
    { path: '/:locale/login', component: LoginPageView, name: 'LoginPage' },
    {
      path: '/:locale/programa-afiliados',
      component: AfiliadosView,
      name: 'AfiliadosPage',
      children: [
        { path: '/:locale/programa-afiliados/:complement', component: AfiliadosView, name: 'AfiliadosPageChild' },
      ]
    },
    { path: '/:locale/minhaconta', component: MyAccountView, name: 'MyAccountPage' },
    { path: '/:locale/modelos', component: ModelsView, name: 'ModelsPage' },
    {
      path: '/:locale/modelos/:name',
      component: ModelView,
      name: 'ModelPage',
      children: [
        { path: '/:locale/modelos/:name/:complement', component: ModelView, name: 'ModelPageChild' }
      ]
    },
    { path: '/:locale/videos', component: VideosView, name: 'VideosPage' },
    { path: '/:locale/lives', component: LivesView, name: 'LivesPage' },
    { path: '/:locale/sobre', component: AboutView, name: 'AboutPage' },
    { path: '/:locale/contato', component: ContactView, name: 'ContactUsPage' },
    { path: '/:locale/colunas', component: ColumnsView, name: 'ColumnsPage' },
    {
      path: '/:locale/colunas/:catergoriaId/:categoriaName/:colunaId/:colunaName',
      component: ColumnIdView,
      name: 'ColumnSingle'
    },
    { path: '/:locale/blog', component: BlogsView, name: 'BlogsPage' },
    { path: '/:locale/blog/:blogId/:blogName', component: BlogIdView, name: 'BlogSingle' },
    { path: '/:locale/ecards', component: EcardsView, name: 'EcardsPage' },
    { path: '/:locale/assine', component: AssineOptionsView, name: 'AssineOptionsPage' },
    { path: '/:locale/prev/assine', component: AssineCreditsView, name: 'AssineCreditsPage' },
    {
      path: '/:locale/assine/checkout',
      component: CheckoutSuccessView,
      name: 'CheckoutSuccessPage'
    },
    {
      path: '/:locale/assine/checkoutCredits',
      component: CheckoutCreditsSuccessView,
      name: 'CheckoutCreditsSuccessPage'
    },
    {
      path: '/:locale/cancel-subscribe/:token',
      component: CancelSubscribeView,
      name: 'CancelSubscribePage'
    },
    { path: '/:locale/live', component: LiveView, name: 'LivePage' },
    {
      path: '/:locale/password-reset/:email/:token',
      component: PasswordResetView,
      name: 'PasswordResetPage'
    },
    // { path: '/:locale/bellacloud', component: MaintenanceView, name: 'MaintenancePage' },
    { path: '/:locale/bellacloud', component: BellaCloudView, name: 'BellaCloudPage' },
    {
      path: '/:locale/bellacloud/album/view/:albumId/:nameAlbum',
      component: BellaCloudAlbumView,
      name: 'BellaCloudAlbumPage'
    },
    { path: '/:locale/bellacloud/top', component: BellaCloudTopView, name: 'BellaCloudTopPage' },
    { path: '/:locale/me/credits', component: MyCreditsView, name: 'MyCreditsPage' },
    { path: '/:locale/buy/credits', component: BuyCreditsView, name: 'BuyCreditsPage' },
    {
      path: '/:locale/me/credits/videos-downloads',
      component: VideosDownloadsView,
      name: 'VideosDownloadsPage'
    },
    {
      path: '/:locale/modelos/lives',
      component: () =>
        (window.location.href =
          '/' +
          (langsAccepts.includes(userLocale.toLowerCase()) ? userLocale.toLowerCase() : 'pt-br') +
          '/modelos')
    },
    { path: '/:locale/homepage-preview', component: HomePreviewView, name: 'HomePreviewPage' },    

    { path: '/:locale/assine/account', component: AssineAccountView, name: 'AssineAccountPage' },
    { path: '/:locale/assine/payment', component: AssineCheckoutView, name: 'AssinePaymentPage' },    
    { path: '/:locale/politica-de-privacidade', component: PolicyPrivacyView, name: 'PolicyPrivacyPage' },
    { path: '/:locale/politica-de-cancelamento', component: PolicyCancellationView, name: 'PolicyCancellationPage' },    
  ],
  scrollBehavior() {
    return { left: 0, top: 0 }
  }
})

export default router
